export enum alertsUrls {
    alerts = "notifications",
    unreadAlertsCount = "notifications/unread/warnings-alerts-count",
    unreadAlerts = "notifications/unread",
    alertsForOrder = "notifications/order"
}